import {cancel, HybirdBridge, invoke, on} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterDeviceStorage extends BridgeMethod {
  constructor() {
    super();
  }

  /**
   * @return {Promise<{
   *  available:int, //可用
   *  total:int //总共
   * }>}
   */
  async getDiskSpace() {
    return invoke("getDiskSpace");
  }


  /**
   *
   * @param callback{function({
   *  available:int, //可用
   *  total:int //总共
   * })}
   * @return {Promise<{function}>} 关闭时使用的callback
   */
  async onDiskSpaceChange(callback) {
    return on("onDiskSpaceChange", callback, {isSend: true});
  }

  /**
   * 使用onDiskSpaceChange中的return或者传入的参数
   * @param callback{function}
   */
  async offDiskSpaceChange(callback) {
    return cancel("onDiskSpaceChange", {event: callback, isSend: true});
  }
}

export const flutterDeviceStorage = new FlutterDeviceStorage();